import React from 'react';
import styled from 'styled-components';

const MobileMenuLabelWrapper = styled.div`
  font-size: 1.2rem;
  padding: 0.25em 0.5em;
`;

export interface IMobileMenuLabelProps
  extends React.HTMLAttributes<HTMLDivElement> {}

export function MobileMenuLabel(props: IMobileMenuLabelProps) {
  return <MobileMenuLabelWrapper {...props} />;
}
